// https://learn.microsoft.com/en-us/azure/azure-monitor/app/api-custom-events-metrics#trackevent
import { appInsights } from "./appInsights";

export const trackEvent = (eventName, properties = {}) => {
    appInsights.trackEvent({ name: eventName, properties })
}